import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=d6b6aa94&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=d6b6aa94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b6aa94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6b6aa94')) {
      api.createRecord('d6b6aa94', component.options)
    } else {
      api.reload('d6b6aa94', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=d6b6aa94&scoped=true&", function () {
      api.rerender('d6b6aa94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24N98mfpOBa4T/JS/comp/GuestBox.vue"
export default component.exports